import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import './styles.scss'

const bc = 'profile-footer'

const ProfileFooter = ({ t, onCancel, pristine, submitting, invalid }) => {
  return (
    <div className={bc}>
      <Button
        primary
        className={`${bc}__btn`}
        type="submit"
        submitting={submitting}
        disabled={submitting || pristine || invalid}
      >
        {t('Save')}
      </Button>
      <Button className={`${bc}__btn`} onClick={onCancel}>
        {t('Cancel')}
      </Button>
    </div>
  )
}

ProfileFooter.propTypes = {
  onCancel: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
}

export default withTranslation()(ProfileFooter)
